import React, { useState } from "react";
import { Star, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ReviewWidget() {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!rating) { toast.error("اختر عدد النجوم أولاً"); return; }
    setSaving(true);
    try {
      await api.post("/reviews", { rating, text });
      setDone(true);
      toast.success("شكراً لتقييمك! سيظهر على صفحتنا 🌟");
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  if (done) {
    return (
      <div className="glass rounded-2xl p-5 border border-border flex items-center gap-3" data-testid="review-widget-done">
        <CheckCircle2 className="w-6 h-6 text-emerald-500 shrink-0" />
        <p className="text-sm text-muted-foreground">تم استلام تقييمك — نشكرك على دعمك لرواج الذكية 💚</p>
      </div>
    );
  }

  return (
    <div className="glass rounded-2xl p-5 border border-border" data-testid="review-widget">
      <h3 className="font-bold mb-1">قيّم تجربتك مع رواج الذكية</h3>
      <p className="text-xs text-muted-foreground mb-3">رأيك يساعد رواد الأعمال الآخرين — وسيظهر تقييمك على صفحتنا الرئيسية.</p>
      <div className="flex gap-1 mb-3" dir="ltr">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
            onClick={() => setRating(n)} data-testid={`review-star-${n}`} className="transition-transform hover:scale-110">
            <Star className={`w-7 h-7 ${(hover || rating) >= n ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"}`} />
          </button>
        ))}
      </div>
      <textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={400} rows={2}
        placeholder="اكتب رأيك (اختياري)…" data-testid="review-text"
        className="w-full bg-secondary border border-border rounded-xl p-3 text-sm resize-none mb-3" />
      <Button onClick={submit} disabled={saving} className="gap-2 bg-primary hover:bg-primary/90 text-white" data-testid="review-submit">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Star className="w-4 h-4" />} إرسال التقييم
      </Button>
    </div>
  );
}
